import PropTypes from 'prop-types';
import account from '#props/account';

export default {
  classes: PropTypes.shape({}),
  account: PropTypes.shape(account)
};
